/**
 * Blurs the currently focused element, if any.
 *
 * Used before closing a MUI Menu/Popover: MUI sets aria-hidden="true" on the
 * closing popover root immediately, and if a MenuItem inside it still has
 * focus at that point, the browser blocks it. Blurring first moves focus out
 * before the popover is hidden.
 */
export const blurActiveElement = (): void => {
  const { activeElement } = document;
  if (activeElement instanceof HTMLElement || activeElement instanceof SVGElement) {
    activeElement.blur();
  }
};
